import api from "../../api/api";

let licenseService = {};
licenseService = {
    isAIInsightsDisabled: false,
    nonSegmentedlicenseName: null,
    isMCPEnabled: false
};

licenseService.init = function() {
    let deferred = $.Deferred();

    (async () => {
        let isAIInsightsDisabled;
        let nonSegmentedlicenseName = null;
        try {
            isAIInsightsDisabled = await api.isLicenseOptionDisableAIInsights();
            licenseService.isAIInsightsDisabled = isAIInsightsDisabled;

            licenseService.isMCPEnabled = await api.isMCPEnabled();

            nonSegmentedlicenseName = await api.isLicenseOptionSQL2FabricSolution();
            const isLicenseOptionSQL2FabricMirroringSolution = await api.isLicenseOptionSQL2FabricMirroringSolution();
            licenseService.nonSegmentedlicenseName =
                nonSegmentedlicenseName || isLicenseOptionSQL2FabricMirroringSolution ? "SQL2FABRICSOLUTION" : null;
            /**
             * SQL2FabricSolution has 2 licenses. SQL2FABRICMIRRORINGSOLUTION and SQL2FABRICSOLUTION
             * Both share the mostly the same UI components. Adding isLiteLicense to differentiate them
             * */
            licenseService.isLiteLicense = !!isLicenseOptionSQL2FabricMirroringSolution;
        } catch (e) {
            console.error(e);
        }
        deferred.resolve();
    })();

    return deferred.promise();
};

export default licenseService;
